import { useEffect, useMemo } from 'react';
import { Cell, Pie, PieChart, Tooltip } from 'recharts';
import useEmissionSpools from '../../../../hooks/web3/vault/useEmissionSpools';

const COLORS = [
    '#2380d6',
    '#23b3e5',
    '#004889',
    '#1ceabc',
    '#a29bfe',
    '#b16bcd',
    '#058859',
    '#11db67',
    '#7662c6',
    '#3f44ad',
];

const EmissionSpoolChart = () => {
    const { emissionSpools } = useEmissionSpools();

    const emissionSpoolsData = useMemo(
        () =>
            emissionSpools &&
            [...emissionSpools]
                .sort((a, b) => {
                    const aValue = parseFloat(a['allocAmount'].toString());
                    const bValue = parseFloat(b['allocAmount'].toString());

                    return (aValue - bValue) * -1;
                })
                ?.slice(0, 10)
                .map(
                    (emissionSpool) => ({
                        name: emissionSpool.spoolName,
                        allocAmount: Math.round(emissionSpool.allocAmount),
                    }),
                    []
                ),
        [emissionSpools]
    );

    useEffect(() => {
        const svg = document.getElementById('doughnut-chart');
        svg?.setAttribute('viewBox', '69 69 162 162');
    }, []);

    return (
        <div className='emission-spools-doughnut'>
            {emissionSpoolsData && (
                <PieChart width={300} height={300} id='doughnut-chart'>
                    <Pie
                        dataKey='allocAmount'
                        data={emissionSpoolsData}
                        innerRadius={55}
                        outerRadius={80}
                        fill='#82ca9d'
                    >
                        {emissionSpoolsData.map((_, index) => (
                            <Cell key={`cell-${index}`} fill={COLORS[index]} />
                        ))}
                    </Pie>
                    <Tooltip />
                </PieChart>
            )}
        </div>
    );
};

export default EmissionSpoolChart;
